<template lang="pug">
  validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
    validation-provider(
      rules="required"
      :name="`Название${type === CARD_TYPES.link ? '' : ' видео'}`"
      vid="name"
      v-slot="{ errors, valid }"
    )
      v-text-field(
        v-model="name"
        :error-messages="errors"
        :label="`Название${type === CARD_TYPES.link ? '' : ' видео'}`"
        rounded filled
      )

    validation-provider(
      :rules="{ ...type === CARD_TYPES.video ? {regex} : {}, required: true }"
      :name="`Ссылка${type === CARD_TYPES.link ? '' : ' на видео'}`"
      vid="url"
      v-slot="{ errors, valid }"
    )
      v-text-field(
        v-model="url"
        :error-messages="errors"
        :label="`Ссылка${type === CARD_TYPES.link ? '' : ' на видео'}`"
        rounded filled
      )
    v-btn(
      color="success"
      @click="handleSubmit(save)"
      text
    ) Продолжить
</template>
<script>
import { YOUTUBE_LINK_REGEX } from '@/utils/youtube-utils';
import { CARD_TYPES } from './constants';

export default {
  props: {
    value: { type: Object, default: () => ({}) },
    type: { type: Number, required: true },
  },
  data() {
    return {
      CARD_TYPES,
      regex: YOUTUBE_LINK_REGEX,
      name: this.value.name,
      url: this.value.link,
    };
  },
  methods: {
    save() {
      this.$emit('success', {
        title: this.name,
        url: this.url,
        type: this.type,
      });
    },
  },
};
</script>
